<template>
  <Dialog
    v-model:visible="showModalRef"
    :close-on-escape="store.getters.dialogsCloseOnEscape"
    :dismissableMask="store.getters.dialogsDismissableMask"
    :modal="store.getters.dialogsModal"
    class="report-has-users-dialog large-dialog"
  >
    <template #header>
      {{ title }}
      <i
        class="custom-close-dialog-button cursor-pointer p-2 pi pi-times"
        @click="closeModal()"
      ></i>
    </template>

    <TabView class="tabview" :lazy="true">
      <!-- Users tab -->
      <TabPanel>
        <template #header>
          <div class="flex align-items-center gap-2">
            <i class="pi pi-user"></i>
            Usuarios
          </div>
        </template>
        <UsersList
          ref="userListRef"
          :informe="informe"
          :idInforme="idInforme"
          :tieneRoles="tieneRoles"
          :Roles="Roles"
          @copy="openCopyUsersAndGroupsModal"
        />
      </TabPanel>

      <!-- Groups tab -->
      <TabPanel>
        <template #header>
          <div class="flex align-items-center gap-2">
            <i class="pi pi-users"></i>
            Grupos
          </div>
        </template>
        <GroupsList
          ref="groupsListRef"
          :informe="informe"
          :grupos="grupos"
          :tieneRoles="tieneRoles"
          :Roles="Roles"
          componentOrigin="report-has-users"
          @copy="openCopyUsersAndGroupsModal"
        />
      </TabPanel>

      <!-- Accesses tab -->
      <TabPanel
        v-if="
          selectedImpersonation
            ? selectedImpersonation.esAdministrador
            : userRol == 'Admin'
        "
      >
        <template #header>
          <div class="flex align-items-center gap-2">
            <i class="pi pi-clock"></i>
            Accesos
          </div>
        </template>
        <Audit :informe="informe" @close="handleClose" />
      </TabPanel>
    </TabView>
  </Dialog>
  <CopyUsersAndGroupsDialogView
    @operationOk="handleCopyUsersAndGroups"
    ref="copyUsersAndGroupsModalRef"
  />
</template>

<script setup>
import { ref } from "vue";
import Dialog from "primevue/dialog";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import { useStore } from "vuex";
import { useAuthorization } from "@sttedra_ui/framework";

import UsersList from "@/pages/_root/report-has-users-dialog/UsersList.vue";
import GroupsList from "@/pages/_root/report-has-users-dialog/GroupsList.vue";
import Audit from "@/pages/_root/report-has-users-dialog/Audit.vue";
import CopyUsersAndGroupsDialogView 
  from "../copy-users-and-groups-dialog/CopyUsersAndGroupsDialogView.vue";

// #region Props, Emits
// #endregion

// #region Params, Ref, Reactives, Computed
const store = useStore();
const informe = ref(null);
const idInforme = ref(null);
const showModalRef = ref(false);
const userListRef = ref(null);
const groupsListRef = ref(null);
const usuarios = ref([]);
const grupos = ref([]);
const tieneRoles = ref(false);
const Roles = ref([]);
const title = ref("Usuarios y grupos del informe");
const copyUsersAndGroupsModalRef = ref(false);

const { modelRef: authorizationModelRef } = useAuthorization();
const userRol = authorizationModelRef.value.roles[0];
const selectedImpersonation = ref(null);
const impersonationToken = localStorage.getItem("impersonationToken");
if (impersonationToken) {
  selectedImpersonation.value = JSON.parse(impersonationToken);
}
// #endregion

// #region Functions
// Open the modal with the data
function showModal(data) {
  informe.value = data;
  idInforme.value = data.idInforme;
  usuarios.value = data.usuarios;
  grupos.value = data.grupos;
  tieneRoles.value = data.tieneRoles;
  Roles.value = data.rolesInforme;
  title.value = `Usuarios y grupos del informe ${data.titulo}`;

  // Show the modal
  showModalRef.value = true;
}

function handleClose() {
  showModalRef.value = false;
}

function closeModal() {
  showModalRef.value = false;
}

function openCopyUsersAndGroupsModal(type) {
  copyUsersAndGroupsModalRef.value.showModal(informe.value.alias, type, false);
}

function handleCopyUsersAndGroups() {
  // Refrescar los datos de usuarios y grupos después de copiar
  if (userListRef.value) {
    userListRef.value.refreshData();
  }
  if (groupsListRef.value) {
    groupsListRef.value.refreshData();
  }
}
// #endregion

// #region Effects, Hooks
// #endregion

// #region Provide, Expose
defineExpose({
  showModal,
});
// #endregion
</script>

<style lang="scss" scoped>
@import "@/styles/_vars.scss";

.tabview {
  :deep(.p-tabview-panels) {
    padding-left: 0;
    padding-right: 0;
  }

  @media (min-width: $mobile-min-width) and (max-width: $tablet-max-width) {
    :deep(.p-tabview-nav-container) {
      .p-tabview-nav {
        .p-tabview-header {
          .p-tabview-nav-link {
            padding: 0.5rem;
          }
        }
      }
    }
  }
}
</style>
